export const SHUFFLE_START_DELAY_MS = 1000;
export const MOOD_SELECT_CLOSE_DELAY_MS = 1000;

// An open Mood/Skin/Settings sheet closes itself if left untouched, so the
// popup returns to the controls instead of sitting on a panel.
export const SHEET_AUTO_CLOSE_MS = 6000;
export const SHARE_COPY_RESET_MS = 3000;
export const HIDDEN_VIDEO_FX_NAMES = ["Pu-241", "Ghost", "Vintage"];

export function normalizeVideoFxs(videoFxs) {
  return Array.isArray(videoFxs) ? videoFxs : [];
}
